import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { guardRoute } from '../../auth/guard.ts'
import { NAV_PATHS } from '../../navigation/paths.ts'
import { rootRoute } from '../root.tsx'

export const officialRequestsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: NAV_PATHS.officialRequests,
  beforeLoad: ({ context, location }) =>
    guardRoute({
      queryClient: context.queryClient,
      requiredRoles: ['club'],
      currentPath: location.href,
    }),
  staticData: { opensOnHero: true },
  component: lazyRouteComponent(() => import('../../pages/official/requests.tsx')),
})

/** The link other pages take the path from, instead of respelling it. */
export const officialRequestsLink = { to: NAV_PATHS.officialRequests } as const
